import React from "react";

const BGStep4: React.FC<React.SVGProps<SVGSVGElement>> = ({
    width,
    height,
}) => {
    return (
      <svg
      width={width || 283}
      height={height || 184}
      viewBox="0 0 283 184"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2070_1397)">
        <mask id="path-1-inside-1_2070_1397" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.148 100.403H179.022C181.407 100.403 183.341 98.6676 183.341 96.5272V3.87574C183.341 1.73522 181.407 0 179.022 0H8.31906C5.9337 0 4 1.73522 4 3.87574V95.7116V96.5272V110.988C4 112.383 5.39128 113.349 6.6981 112.862L40.148 100.403Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.148 100.403H179.022C181.407 100.403 183.341 98.6676 183.341 96.5272V3.87574C183.341 1.73522 181.407 0 179.022 0H8.31906C5.9337 0 4 1.73522 4 3.87574V95.7116V96.5272V110.988C4 112.383 5.39128 113.349 6.6981 112.862L40.148 100.403Z"
          fill="white"
        />
        <path
          d="M40.148 100.403V99.903H40.0579L39.9735 99.9344L40.148 100.403ZM6.6981 112.862L6.87262 113.331L6.87262 113.331L6.6981 112.862ZM179.022 99.903H40.148V100.903H179.022V99.903ZM182.841 96.5272C182.841 98.3419 181.183 99.903 179.022 99.903V100.903C181.631 100.903 183.841 98.9933 183.841 96.5272H182.841ZM182.841 3.87574V96.5272H183.841V3.87574H182.841ZM179.022 0.5C181.183 0.5 182.841 2.06092 182.841 3.87574H183.841C183.841 1.40951 181.631 -0.5 179.022 -0.5V0.5ZM8.31906 0.5H179.022V-0.5H8.31906V0.5ZM4.5 3.87574C4.5 2.06091 6.15753 0.5 8.31906 0.5V-0.5C5.70986 -0.5 3.5 1.40952 3.5 3.87574H4.5ZM4.5 95.7116V3.87574H3.5V95.7116H4.5ZM4.5 96.5272V95.7116H3.5V96.5272H4.5ZM4.5 110.988V96.5272H3.5V110.988H4.5ZM6.52358 112.394C5.54346 112.759 4.5 112.034 4.5 110.988H3.5C3.5 112.731 5.23909 113.939 6.87262 113.331L6.52358 112.394ZM39.9735 99.9344L6.52357 112.394L6.87262 113.331L40.3226 100.872L39.9735 99.9344Z"
          fill="#94A3B8"
          mask="url(#path-1-inside-1_2070_1397)"
        />
      </g>
      <path
        d="M51.531 52C51.6554 52 51.7747 52.1435 51.8625 52.4014C51.9506 52.6593 52 53.0091 52 53.375V56.125C52 56.3055 51.988 56.4845 51.9644 56.6521C51.9409 56.8182 51.9063 56.9697 51.8625 57.097C51.819 57.226 51.7673 57.3259 51.7105 57.3952C51.6536 57.4646 51.5924 57.5 51.531 57.5H14.4691C14.4075 57.5 14.3465 57.4646 14.2896 57.3952C14.2327 57.3259 14.181 57.226 14.1374 57.097C14.0938 56.9697 14.0593 56.8182 14.0357 56.6521C14.0121 56.4845 14 56.3055 14 56.125V53.375C14 53.1945 14.0121 53.0155 14.0357 52.8479C14.0593 52.6819 14.0939 52.5303 14.1374 52.4014C14.181 52.274 14.2327 52.1725 14.2896 52.1048C14.3465 52.0354 14.4075 52 14.4691 52H51.531Z"
        fill="#D9D9D9"
      />
      <path
        d="M171.038 65C171.558 65 172.057 65.1318 172.425 65.3662C172.793 65.6006 173 65.9185 173 66.2496V68.7504C173 68.9144 172.95 69.0771 172.851 69.228C172.753 69.3803 172.608 69.518 172.425 69.6338C172.243 69.7495 172.026 69.8418 171.789 69.9048C171.551 69.9678 171.295 70 171.038 70H15.9635C15.7053 70 15.4504 69.9678 15.2115 69.9048C14.9737 69.8418 14.7573 69.7495 14.5752 69.6338C14.3931 69.518 14.2485 69.3803 14.1489 69.228C14.0504 69.0771 14 68.9144 14 68.7504V66.2496C14 66.0856 14.0504 65.923 14.1489 65.7721C14.2485 65.6197 14.3931 65.482 14.5752 65.3662C14.7573 65.2505 14.9737 65.1582 15.2115 65.0952C15.4504 65.0322 15.7053 65 15.9635 65H171.038Z"
        fill="#D9D9D9"
      />
      <path
        d="M134.926 77C135.327 77 135.711 77.1435 135.994 77.4014C136.278 77.6593 136.437 78.0091 136.437 78.375V81.125C136.437 81.3055 136.398 81.4845 136.322 81.6521C136.247 81.8182 136.135 81.9697 135.994 82.097C135.854 82.226 135.687 82.3259 135.504 82.3952C135.321 82.4646 135.124 82.5 134.926 82.5H15.512C15.3132 82.5 15.1169 82.4646 14.9329 82.3952C14.7498 82.3259 14.5832 82.226 14.443 82.097C14.3027 81.9697 14.1914 81.8182 14.1147 81.6521C14.0388 81.4845 14 81.3055 14 81.125V78.375C14 78.1945 14.0388 78.0155 14.1147 77.8479C14.1914 77.6819 14.3027 77.5303 14.443 77.4014C14.5832 77.274 14.7498 77.1725 14.9329 77.1048C15.1169 77.0354 15.3132 77 15.512 77H134.926Z"
        fill="#D9D9D9"
      />
      <path
        d="M51.531 15C51.6554 15 51.7747 15.1435 51.8625 15.4014C51.9506 15.6593 52 16.0091 52 16.375V19.125C52 19.3055 51.988 19.4845 51.9644 19.6521C51.9409 19.8182 51.9063 19.9697 51.8625 20.097C51.819 20.226 51.7673 20.3259 51.7105 20.3952C51.6536 20.4646 51.5924 20.5 51.531 20.5H14.4691C14.4075 20.5 14.3465 20.4646 14.2896 20.3952C14.2327 20.3259 14.181 20.226 14.1374 20.097C14.0938 19.9697 14.0593 19.8182 14.0357 19.6521C14.0121 19.4845 14 19.3055 14 19.125V16.375C14 16.1945 14.0121 16.0155 14.0357 15.8479C14.0593 15.6819 14.0939 15.5303 14.1374 15.4014C14.181 15.274 14.2327 15.1725 14.2896 15.1048C14.3465 15.0354 14.4075 15 14.4691 15H51.531Z"
        fill="#D9D9D9"
      />
      <path
        d="M171.038 28C171.558 28 172.057 28.1318 172.425 28.3662C172.793 28.6006 173 28.9185 173 29.2496V31.7504C173 31.9144 172.95 32.0771 172.851 32.228C172.753 32.3803 172.608 32.518 172.425 32.6338C172.243 32.7495 172.026 32.8418 171.789 32.9048C171.551 32.9678 171.295 33 171.038 33H15.9635C15.7053 33 15.4504 32.9678 15.2115 32.9048C14.9737 32.8418 14.7573 32.7495 14.5752 32.6338C14.3931 32.518 14.2485 32.3803 14.1489 32.228C14.0504 32.0771 14 31.9144 14 31.7504V29.2496C14 29.0856 14.0504 28.923 14.1489 28.7721C14.2485 28.6197 14.3931 28.482 14.5752 28.3662C14.7573 28.2505 14.9737 28.1582 15.2115 28.0952C15.4504 28.0322 15.7053 28 15.9635 28H171.038Z"
        fill="#D9D9D9"
      />
      <path
        d="M134.926 40C135.327 40 135.711 40.1435 135.994 40.4014C136.278 40.6593 136.437 41.0091 136.437 41.375V44.125C136.437 44.3055 136.398 44.4845 136.322 44.6521C136.247 44.8182 136.135 44.9697 135.994 45.097C135.854 45.226 135.687 45.3259 135.504 45.3952C135.321 45.4646 135.124 45.5 134.926 45.5H15.512C15.3132 45.5 15.1169 45.4646 14.9329 45.3952C14.7498 45.3259 14.5832 45.226 14.443 45.097C14.3027 44.9697 14.1914 44.8182 14.1147 44.6521C14.0388 44.4845 14 44.3055 14 44.125V41.375C14 41.1945 14.0388 41.0155 14.1147 40.8479C14.1914 40.6819 14.3027 40.5303 14.443 40.4014C14.5832 40.274 14.7498 40.1725 14.9329 40.1048C15.1169 40.0354 15.3132 40 15.512 40H134.926Z"
        fill="#D9D9D9"
      />
      <g filter="url(#filter1_d_2070_1397)">
        <mask id="path-9-inside-2_2070_1397" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M242.192 161.673H103.319C100.934 161.673 98.9998 159.743 98.9998 157.362V54.3108C98.9998 51.93 100.934 50 103.319 50H274.022C276.407 50 278.341 51.93 278.341 54.3108V156.231V157.362V173.655C278.341 175.081 276.892 176.049 275.575 175.503L242.192 161.673Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M242.192 161.673H103.319C100.934 161.673 98.9998 159.743 98.9998 157.362V54.3108C98.9998 51.93 100.934 50 103.319 50H274.022C276.407 50 278.341 51.93 278.341 54.3108V156.231V157.362V173.655C278.341 175.081 276.892 176.049 275.575 175.503L242.192 161.673Z"
          fill="white"
        />
        <path
          d="M242.192 161.673V161.173H242.292L242.384 161.211L242.192 161.673ZM275.575 175.503L275.384 175.965L275.384 175.965L275.575 175.503ZM103.319 161.173H242.192V162.173H103.319V161.173ZM99.4998 157.362C99.4998 159.466 101.209 161.173 103.319 161.173V162.173C100.658 162.173 98.4998 160.02 98.4998 157.362H99.4998ZM99.4998 54.3108V157.362H98.4998V54.3108H99.4998ZM103.319 50.5C101.209 50.5 99.4998 52.207 99.4998 54.3108H98.4998C98.4998 51.6529 100.658 49.5 103.319 49.5V50.5ZM274.022 50.5H103.319V49.5H274.022V50.5ZM277.841 54.3108C277.841 52.207 276.132 50.5 274.022 50.5V49.5C276.682 49.5 278.841 51.6529 278.841 54.3108H277.841ZM277.841 156.231V54.3108H278.841V156.231H277.841ZM277.841 157.362V156.231H278.841V157.362H277.841ZM277.841 173.655V157.362H278.841V173.655H277.841ZM275.767 175.041C276.754 175.45 277.841 174.724 277.841 173.655H278.841C278.841 175.437 277.03 176.647 275.384 175.965L275.767 175.041ZM242.384 161.211L275.767 175.041L275.384 175.965L242.001 162.135L242.384 161.211Z"
          fill="#94A3B8"
          mask="url(#path-9-inside-2_2070_1397)"
        />
      </g>
      <path
        d="M263.112 86C263.613 86 264.093 86.1304 264.447 86.3649C264.801 86.5993 265 86.9188 265 87.25V89.75C265 89.9141 264.952 90.0768 264.857 90.2292C264.762 90.3801 264.623 90.5179 264.447 90.6336C264.271 90.7509 264.063 90.8432 263.834 90.9048C263.605 90.9678 263.359 91 263.112 91H113.889C113.641 91 113.396 90.9678 113.166 90.9048C112.937 90.8432 112.729 90.7509 112.554 90.6336C112.378 90.5179 112.239 90.3801 112.143 90.2292C112.048 90.0768 112 89.9141 112 89.75V87.25C112 87.0859 112.048 86.9232 112.143 86.7708C112.239 86.6199 112.378 86.4821 112.554 86.3649C112.729 86.2491 112.937 86.1568 113.166 86.0952C113.396 86.0322 113.641 86 113.889 86H263.112Z"
        fill="#A6D8A7"
      />
      <path
        d="M263.371 98C263.803 98 264.217 98.1304 264.522 98.3649C264.828 98.5993 265 98.9188 265 99.25V101.75C265 101.914 264.958 102.077 264.876 102.229C264.795 102.38 264.675 102.518 264.522 102.634C264.371 102.751 264.192 102.843 263.994 102.905C263.797 102.968 263.584 103 263.371 103H134.63C134.416 103 134.204 102.968 134.006 102.905C133.808 102.843 133.629 102.751 133.478 102.634C133.326 102.518 133.206 102.38 133.124 102.229C133.042 102.077 133 101.914 133 101.75V99.25C133 99.0859 133.042 98.9232 133.124 98.7708C133.206 98.6199 133.326 98.4821 133.478 98.3649C133.629 98.2491 133.808 98.1568 134.006 98.0952C134.204 98.0322 134.416 98 134.63 98H263.371Z"
        fill="#A6D8A7"
      />
      <path
        d="M263.371 134C263.803 134 264.217 134.13 264.522 134.365C264.828 134.599 265 134.919 265 135.25V137.75C265 137.914 264.958 138.077 264.876 138.229C264.795 138.38 264.675 138.518 264.522 138.634C264.371 138.751 264.192 138.843 263.994 138.905C263.797 138.968 263.584 139 263.371 139H134.63C134.416 139 134.204 138.968 134.006 138.905C133.808 138.843 133.629 138.751 133.478 138.634C133.326 138.518 133.206 138.38 133.124 138.229C133.042 138.077 133 137.914 133 137.75V135.25C133 135.086 133.042 134.923 133.124 134.771C133.206 134.62 133.326 134.482 133.478 134.365C133.629 134.249 133.808 134.157 134.006 134.095C134.204 134.032 134.416 134 134.63 134H263.371Z"
        fill="#A6D8A7"
      />
      <path
        d="M263.766 74C264.093 74 264.407 74.1311 264.638 74.3668C264.87 74.6007 265 74.9194 265 75.2496V77.7504C265 78.0823 264.87 78.3993 264.638 78.6349C264.407 78.8689 264.093 79 263.766 79H166.235C165.907 79 165.593 78.8689 165.362 78.6349C165.13 78.3993 165 78.0823 165 77.7504V75.2496C165 74.9194 165.13 74.6007 165.362 74.3668C165.593 74.1311 165.907 74 166.235 74H263.766Z"
        fill="#E98583"
      />
      <path
        d="M264.136 110C264.365 110 264.585 110.131 264.747 110.367C264.909 110.601 265 110.919 265 111.25V113.75C265 114.082 264.909 114.399 264.747 114.635C264.585 114.869 264.365 115 264.136 115H195.864C195.635 115 195.415 114.869 195.253 114.635C195.091 114.399 195 114.082 195 113.75V111.25C195 110.919 195.091 110.601 195.253 110.367C195.415 110.131 195.635 110 195.864 110H264.136Z"
        fill="#E98583"
      />
      <path
        d="M263.926 122C264.327 122 264.711 122.145 264.994 122.403C265.278 122.661 265.437 123.01 265.437 123.375V126.125C265.437 126.306 265.398 126.485 265.322 126.651C265.247 126.818 265.135 126.97 264.994 127.097C264.854 127.224 264.687 127.326 264.504 127.395C264.321 127.465 264.124 127.5 263.926 127.5H144.512C144.313 127.5 144.117 127.465 143.933 127.395C143.75 127.326 143.583 127.224 143.443 127.097C143.303 126.97 143.191 126.818 143.115 126.651C143.039 126.485 143 126.306 143 126.125V123.375C143 123.194 143.039 123.015 143.115 122.849C143.191 122.682 143.303 122.53 143.443 122.403C143.583 122.276 143.75 122.174 143.933 122.105C144.117 122.035 144.313 122 144.512 122H263.926Z"
        fill="#D9D9D9"
      />
      <defs>
        <filter
          id="filter0_d_2070_1397"
          x={0}
          y={0}
          width="187.341"
          height="120.99"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2070_1397"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2070_1397"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2070_1397"
          x="94.9998"
          y={50}
          width="187.341"
          height="133.657"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2070_1397"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2070_1397"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
    
    );
};

export default BGStep4;
